import { MainpageFiltersType } from '../pages/Mainpage/types';

export const generateTextbookXlsQueries = (props: MainpageFiltersType) => {
  return `?${Object.keys(props)
    .filter((el) => !!props[el])
    .map((key) => `${key}=${props[key]}`)
    .join('&')}`;
};
